// 接口模块
import request from '@/utils/request'
/**
 * 获取所有数据
 */
export function getAllData () {
  return request({
    url: '/getAllDatamap',
    method: 'get'
  })
}
/**
 * 模糊查询
 */
export function getDataByKeywords (params) {
  return request({
    url: '/getDataByKeywords',
    method: 'get',
    params
  })
}
export function getDataArea(params) {
  return request({
    url: '/getDataArea',
    method: 'get',
    params
  })
}

export function getDataLevel(params) {
  return request({
    url: '/getDataLevel',
    method: 'get',
    params
  })
}

export function getDataByLocationAndProtected(params) {
  return request({
    url: '/getDataByLocationAndProtected',
    method: 'get',
    params
  })
}

export function robotstxt () {
  return request({
    url: '/robots.txt',
    method: 'get'
  })
}
